<template>
  <div>
    <Head title="Editar producto" />
    
    <!-- Header -->
    <div class="flex items-center gap-4 mb-8">
      <button 
        class="p-3 text-white bg-teal-700 hover:bg-teal-800 rounded-lg transition-colors"
        title="Volver atrás"
        @click="back()"
      >
        <i class="fa fa-arrow-left"></i>
      </button>
      <h1 class="text-3xl font-bold">
        <Link 
          class="text-teal-600 hover:text-teal-700 transition-colors" 
          href="/products"
        >
          Productos
        </Link>
        <span class="text-gray-400 font-medium mx-2">/</span>
        <Link 
          class="text-teal-600 hover:text-teal-700 transition-colors"
          :href="`/products/${product.id}`"
        >
          {{ form.name }}
        </Link>
        <span class="text-gray-400 font-medium mx-2">/</span>
        <span>Editar</span>
      </h1>
    </div>

    <!-- Form -->
    <div class="max-w-4xl bg-white rounded-lg shadow-sm border border-gray-200">
      <form @submit.prevent="update">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input v-model="form.code" :errors="form.errors.code" class="pb-8 pr-6 w-full lg:w-1/2" label="Codigo" />
          <text-input v-model="form.name" :errors="form.errors.name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre" />
          <text-input v-model="form.description" :errors="form.errors.description" class="pb-8 pr-6 w-full lg:w-1/2" label="Descripcion" />
          <!-- <text-input v-model="form.line_name" :error="form.errors.line_name" class="pb-8 pr-6 w-full lg:w-1/2" label="Nombre de linea" /> -->
          <!-- <text-input v-model="form.alias" :error="form.errors.alias" class="pb-8 pr-6 w-full lg:w-1/2" label="Alias" /> -->
          <text-input
            v-for="(group, key) in groups"
            :key="group.id"
            v-model.number="form.prices[key]"
            type="numeric"
            :errors="form.errors.price"
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="`Precio ${group.name}`"
          />
          <text-input v-model="form.price_cop" :error="form.errors.price_cop" class="pb-8 pr-6 w-full lg:w-1/2" label="Precio en pesos" />
          <text-input v-model="form.cost" :error="form.errors.cost" class="pb-8 pr-6 w-full lg:w-1/2" label="Costo" />
          <select-input v-model="form.brand_id" class="pb-8 pr-6 w-full lg:w-1/2" label="Marca">
            <option value="">Seleccionar</option>
            <option v-for="(brand, key) in brands" :key="key" :value="brand.id">{{ brand.name }}</option>
          </select-input>

          <!-- Prices -->
          <div class="lg:col-span-2">
            <h2 class="text-lg font-bold mb-4">Precios</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <text-input
                v-model="form.cost"
                :error="form.errors.cost"
                label="Costo *"
                type="number"
                step="0.01"
                placeholder="Ingrese el costo"
              />
              <text-input
                v-for="(group, key) in groups"
                :key="group.id"
                v-model.number="form.prices[key]"
                type="number"
                :error="form.errors.prices"
                :label="`Precio ${group.name} *`"
                step="0.01"
                placeholder="Ingrese el precio"
              />
            </div>
          </div>

          <!-- Categories -->
          <div class="lg:col-span-2">
            <h2 class="text-lg font-bold mb-4">Categorización</h2>
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <select-input
                v-model="form.brand_id"
                :error="form.errors.brand_id"
                label="Marca *"
              >
                <option value="">Seleccionar marca</option>
                <option
                  v-for="brand in brands"
                  :key="brand.id"
                  :value="brand.id"
                >
                  {{ brand.name }}
                </option>
              </select-input>

              <select-input
                v-model="form.product_category_id"
                :error="form.errors.product_category_id"
                label="Categoría *"
              >
                <option value="">Seleccionar categoría</option>
                <option
                  v-for="category in productCategories"
                  :key="category.id"
                  :value="category.id"
                >
                  {{ category.name }}
                </option>
              </select-input>

              <select-input
                v-model="form.contable"
                :error="form.errors.contable"
                label="Contable *"
              >
                <option value="">Seleccionar opción</option>
                <option value="0">No</option>
                <option value="1">Sí</option>
              </select-input>

              <select-input
                v-model="form.is_decimal"
                :error="form.errors.is_decimal"
                label="¿Se vende en decimales? *"
              >
                <option value="">Seleccionar opción</option>
                <option :value="1">Sí</option>
                <option :value="0">No</option>
              </select-input>

              <text-input
                v-model="form.min_stock"
                :error="form.errors.min_stock"
                type="number"
                label="Stock Mínimo (Piso)"
                placeholder="Ingrese el stock mínimo"
              />

              <text-input
                v-model="form.max_stock"
                :error="form.errors.max_stock"
                type="number"
                label="Stock Máximo (Techo)"
                placeholder="Ingrese el stock máximo"
              />

              <file-input
                v-model="form.photo"
                :error="form.errors.photo"
                type="file"
                accept="image/*"
                label="Foto del producto"
              />
            </div>
          </div>
        </div>

        <!-- Actions -->
        <div class="flex items-center justify-between px-8 py-4 bg-gray-50 border-t">
          <button
            type="button"
            class="text-red-600 hover:text-red-700 font-medium transition-colors"
            @click="destroy"
          >
            Eliminar producto
          </button>
          
          <loading-button
            :loading="form.processing"
            class="btn-blue"
          >
            Actualizar producto
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import FileInput from '@/Shared/FileInput'

export default {
  name: 'ProductEdit',

  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    FileInput
  },

  layout: Layout,

  remember: 'form',

  props: {
    product: Object,
    groups: Object,
    brands: Object,
    parts: Object,
    productCategories: Object
  },

  data() {
    return {
      form: this.$inertia.form({
        _method: 'put',
        code: this.product.code,
        id: this.product.id,
        name: this.product.name,
        line_name: this.product.line_name,
        description: this.product.description,
        volumen: this.product.volumen,
        weight: this.product.weight,
        prices: [
          this.product?.prices[0]?.price
        ],
        brand_id: this.product.brand_id,
        part_id: this.product.part_id,
        alias: this.product.alias,
        contable: this.product.contable,
        cost: this.product.cost,
        photo: null,
        product_category_id: this.product.product_category_id,
        price_cop: this.product.price_cop,
        is_decimal: this.product.is_decimal,
        min_stock: this.product.min_stock ?? 5,
        max_stock: this.product.max_stock ?? 100
      }),
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    update() {
      this.form.post(`/products/${this.form.id}`)
    },

    destroy() {
      if (confirm('¿Está seguro que desea eliminar este producto?')) {
        this.$inertia.delete(`/products/${this.product.id}`)
      }
    },
  },
}
</script>
